/**
 * @fileoverview GET handler for the "/alloys/partners/:alloys_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersAlloysId } from "./constants";
import type { AlloysPartnersAlloysIdResult } from "./types";

export const getAlloysPartnersAlloysId = reactQueryFetcherAdapter(
  alloysPartnersAlloysId,
  (signal: AbortSignal, alloysId: string): Promise<AlloysPartnersAlloysIdResult> => {
    return fetch(`/alloys/partners/${alloysId}`, "GET", {}, { signal });
  }
);
